import {
  BETWEEN_SITE_CAR_BOOKINGS_FETCHING,
  BETWEEN_SITE_CAR_BOOKINGS_FAILED,
  BETWEEN_SITE_CAR_BOOKINGS_SUCCESS,
} from "./types";

import betweenSiteCarService from "../services/betweenSiteCar.service";

export const getBetweenSiteCarByFilter =
  (filter) => async (dispatch) => {
    try {
      dispatch({
        type: BETWEEN_SITE_CAR_BOOKINGS_FETCHING,
      });
      const res =
        await betweenSiteCarService.getBetweenSiteCarByFilter(filter);
      if (res) {
        dispatch({
          type: BETWEEN_SITE_CAR_BOOKINGS_SUCCESS,
          payload: res.data,
        });
      }
    } catch (error) {
      dispatch({
        type: BETWEEN_SITE_CAR_BOOKINGS_FAILED,
      });
    }
  };

export const getBetweenSiteByAdminFilter = (date) => async (dispatch) => {
  try {
    dispatch({
      type: BETWEEN_SITE_CAR_BOOKINGS_FETCHING,
    });
    const res = await betweenSiteCarService.getBetweenSiteByAdminFilter(date);
    if (res) {
      dispatch({
        type: BETWEEN_SITE_CAR_BOOKINGS_SUCCESS,
        payload: res.data,
      });
    }
  } catch (error) {
    dispatch({
      type: BETWEEN_SITE_CAR_BOOKINGS_FAILED,
    });
  }
};
